<template>
  <div class="search-tool-tip-modal">
    <button
        class="enable-search-tooltip btn"
        data-toggle="infoModal"
        data-target="#infoModal"
        data-whatever="@mdo"
        aria-label="Suchhinweis"
        @click="handleClick"
    >
      <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#6b6c6c"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: "search-tooltip",
  data() {
    return {
      showInfo: false,
    };
  },
  methods: {
    handleClick() {
      $("#infoModal").modal("show");
    },
  },
};
</script>
